import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JurisdictionDiffPopupComponent } from './jurisdiction-diff-popup.component';
import { ButtonModule } from '@shared';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [JurisdictionDiffPopupComponent],
  imports: [CommonModule, ButtonModule, MatDialogModule, TranslateModule],
})
export class JurisdictionDiffPopupModule {}
